import React, { memo, useCallback } from 'react';
import noop from 'lodash/noop';
import { useHistory } from 'react-router-dom';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, GHOST_VARIANT, LEADING_ICON, SIZE_44, TRAILING_ICON, } from '@yme/atoms/button';
import { Container, Col, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { getBackStepRouteName } from '../helpers';
import { FlexWrapperContainer, ForwardButtonContainerStyled } from './ButtonsNavBarStyled';
export const ButtonsNavBar = memo(({ isNextDisabled, backButtonLabel, forwardButtonLabel, isLoading = false, onForwardPress = noop, }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const handleBack = useCallback(() => {
        history.replace(getBackStepRouteName(history.location.pathname));
    }, [history]);
    return (React.createElement(Container, { width: "100%" },
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 8 },
                React.createElement(FlexWrapperContainer, { justifyContent: "space-between", isMobileView: isMobileView },
                    React.createElement(Button, { width: isMobileView ? '100%' : 'auto', size: SIZE_44, buttonVariant: GHOST_VARIANT, hasIconButton: LEADING_ICON, iconRotate: false ? 0 : 180, iconComponent: ArrowForward, label: backButtonLabel || t('returnForm_back_button'), onClick: handleBack }),
                    React.createElement(ForwardButtonContainerStyled, null,
                        React.createElement(Button, { type: "submit", width: isMobileView ? '100%' : 'auto', size: SIZE_44, buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconRotate: false ? 180 : 0, iconComponent: ArrowForward, disabled: isNextDisabled, label: forwardButtonLabel || t('returnForm_continue_button'), onClick: onForwardPress, isLoading: isLoading })))))));
});
ButtonsNavBar.displayName = 'ButtonsNavBar_ReturnForm';
